import { Injectable } from "@angular/core";

declare let window: any;

const GROOVE_WIDGET_ID = "fdb487f9-dd4a-484e-b063-b2c1b70dd30d";
const GROOVE_MESSAGE_SOURCE = "groove-widget";

@Injectable({ providedIn: "root" })
export class SupportService {
  private initialized = false;
  private wasOpen = false;
  private messageListener: (event: MessageEvent) => void;

  public open(): void {
    if (!this.initialized) {
      window.groove.widget = window.groove.createWidget();
      window.groove.widget.init(GROOVE_WIDGET_ID, {});
      this.listenForClose();
      this.initialized = true;
    }

    window.groove.widget.open();
  }

  /**
   * Groove leaves its own launcher bubble on screen once the user closes the
   * widget. The widget is only ever opened from the header, so destroy it on
   * close and recreate it on the next open.
   */
  private listenForClose(): void {
    this.messageListener = (event: MessageEvent) => {
      if (event.data?.source !== GROOVE_MESSAGE_SOURCE) {
        return;
      }

      if (window.groove.widget?.shim?.isOpen) {
        this.wasOpen = true;

        return;
      }

      if (this.wasOpen) {
        this.destroy();
      }
    };

    window.addEventListener("message", this.messageListener);
  }

  private destroy(): void {
    window.removeEventListener("message", this.messageListener);
    window.groove.widget?.destroy();
    this.initialized = false;
    this.wasOpen = false;
  }
}
